PopoverContent = (props) ->
  <div className='gdt-popover-content-box' {...R.omit(['children'], props)}>
    {props.children}
  </div>

module.exports = PopoverContent
